import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Box, Card, CardHeader, Grid, IconButton, LinearProgress, ListItemIcon, Menu, MenuItem, Alert, AlertTitle,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV, faEdit } from '@fortawesome/free-solid-svg-icons';
import md from '../../../const/meta';
import { ErrorMessage } from '../../../components/Styled/Misc';
import { EStateFieldIcon } from '../../../components/Styled/Buttons/icons';
import usePayerItems from './hooks';

function PayerRealies({ payerId }) {
  const {
    items, loading, err, selectedId, setSelectedId,
  } = usePayerItems({ payerId, subUrl: 'get_realty' });

  return (
    <>
      <Grid container spacing={2}>
        {loading && (
          <Grid item sm={12}>
            <Box sx={{ width: '100%' }}>
              <LinearProgress />
            </Box>
          </Grid>
        )}
        {err && (
          <Grid item sm={12}>
            <ErrorMessage text={err} />
          </Grid>
        )}
        {!items.length && !loading && (
          <Grid item xs={12}>
            <Alert severity="info" variant="outlined">
              <AlertTitle>Важлива інформація</AlertTitle>
              Нерухомість відсутня
            </Alert>
          </Grid>
        )}
        {items.map(((item) => (
          <Grid item sm={3} key={item.id}>
            <Card>
              <CardHeader
                avatar={<img src={EStateFieldIcon} alt="" />}
                title={item.address}
                subheader={`${item.area} м², ${item.purpose}, ${item.realty_type || ''}`}
                action={(
                  <IconButton
                    aria-label="menu"
                    id={`menu-button-${item.id}`}
                    onClick={() => setSelectedId(item.id)}
                  >
                    <FontAwesomeIcon icon={faEllipsisV} />
                  </IconButton>
                )}
              />
            </Card>
          </Grid>
        )))}
      </Grid>
      <Menu
        anchorEl={() => document.getElementById(`menu-button-${selectedId}`)}
        open={!!selectedId}
        onClose={() => setSelectedId(null)}
      >
        <MenuItem onClick={() => null}>
          <Link to={`${md.cat.realty.frontend}${selectedId}`}>
            <ListItemIcon>
              <FontAwesomeIcon icon={faEdit} />
            </ListItemIcon>
            Детальніше
          </Link>
        </MenuItem>
      </Menu>
    </>
  );
}

PayerRealies.propTypes = {
  payerId: PropTypes.number.isRequired,
};
export default PayerRealies;
